module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b', [_vm._v("Chapter 2")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "alt": "flourish",
      "src": "images/flourish.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('span', {
    staticClass: "s3"
  }, [_vm._v("\"D")]), _vm._v("id you get a look at any of them, Cody?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Cody dropped his arm, tensed into a rigid barricade to keep Shanna from passing, and wrenched his eyes from Shanna's bewildered, mud-smeared face to Dan, standing in the shattered doorway of the land office. He rolled his shoulders, loosening the tension, immediately glad for the interruption.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Not a good enough look to identify anyone,\" he admitted, his mind adding the silent words 'at least for sure'. He'd deal with that other, nagging suspicion later. \"They had their hats low and collars up,\" he told Dan instead. \"And those last five who rode in wore bandannas. The horses shouldn't be hard to recognize, though.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Yeah, if we've got anything around here that can catch them after all those Jayhawker raids during the war,\" Dan said in disgust. \"You ready to ride? My deputies are gathering a posse.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('span', {
    staticClass: "Apple-converted-space"
  }), _vm._v("Cody strode across the littered floor, resolutely pushing aside the shattered look his rash demand had left on Shanna's face. \"How much did they get from the bank?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Cleaned it out. Don't have a count yet. I'll be back in a second with your horse.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Toby, stop!\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Cody instinctively grabbed the back of the little boy's coat. He lifted Toby off the ground, ignoring the boy's cries of outrage, his windmilling legs and hands balled into fists, trying to reach over his small shoulders.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Let go of me!\" Toby demanded. \"I wanna go see what happened!\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Cody's lips tightened in impatience and he barely kept himself from shaking the struggling figure. Wasn't he ever going to cut loose from these two tenderfeet and go after his bank account?")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He started to turn and thrust his twisting burden at the boy's sister, but glanced out into the street. An uncompromising look stole over his face and he dropped Toby back to his feet. Taking a firm grip on the slight shoulders, Cody forced the boy to look toward the small party of men Dan had joined.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"All right, young'un,\" he said in an icy voice. \"Is that what you want to see?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Shanna's face blanched when she followed Cody's gaze. Two men bent down to pick up the prone body of the young man who had drawn the robber's attention away from her and Toby, allowing them to escape almost certain death. Blood soaked the front of the man's jacket and his head lolled on his chest when the men lifted him by his feet and shoulders. A black-clad man stood and picked up a medical bag by his feet, shaking his head sadly.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("For just a second, Shanna's mind superimposed the quick glimpse she'd had of the young man running toward them over the still, dead body. He had been still alive at that moment—such a brief second ago in time. Now he was lifeless, his future gone—somewhere a mother who would waste away in grief when she got the news, as Shanna would have had the body been Toby's.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Cody knelt behind Toby and shook the boy's shoulders. Despite the whimpers emerging from Toby's throat, Cody kept the boy's face pointed at the scene in the street.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Is it, son?\" he asked again. \"Did you want to see some dead bodies? Sorry, but we've only got one to show you today. Maybe there'll be more next time.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Toby's small frame shook with a sob, penetrating Shanna's dazed senses and tearing at her heart, shocking her back to the realization that her very much alive little brother was suffering a brute manhandling. Anger flared and she surged forward, reaching for Toby.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Get your hands off him! Give him to me!\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I'm not done yet,\" Cody said as he turned Toby around to face him.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Oh yes, you are,\" Shanna gritted through clenched teeth, her fist balled in case she had to make her point in a more violent manner. \"Just because you protected us a minute ago doesn't give you the right to push my little brother around! Leave him alone, or I'll have you arrested!\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Cody tossed her a brief glance. The dangerous glint in his eyes clashed with her pugnacious stance, quelling Shanna in her tracks. Then he ignored her and pulled Toby's small fists from his eyes, where Toby tried to stem the tears running down his cheeks. Blood and moisture soaked the handkerchief bandaging Toby's hand now, reminding Cody of how bravely the little boy had tolerated the pain from his wound.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I want you to remember this day, son,\" Cody said in a softer voice. \"There's nothing exciting about men killing other men. And on top of that, a lot of good people lost their life savings today. If we can't catch those robbers, the people who had money in the bank will be wiped out. Do you understand what I'm trying to say, or am I going to have to take you out there for a closer look?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Y... you bully! You sorry b... bastard!\" Shanna sputtered, her courage returning now that she didn't have to contend with that obsidian stare. \"He's only five. I suppose it makes you feel proud of yourself to terrorize a five-year-old little boy a quarter of your size!\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Boys grow up fast out here,\" Cody said without taking his eyes from Toby's face. \"Between the hard living and the war, a lot of them don't have much of a chance to be children. In fact, you both better start thinking about the consequences of your actions around here before you go blundering into more danger. And....\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Cody finally allowed himself another look at the outraged package of fury hovering on the brink of a full-fledged assault on him. \"...you didn't think I was such a "), _c('i', [_vm._v("bastard")]), _vm._v(" when I kept both of you from stopping a bullet!\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Shanna fumed in rage, unable to rationalize a suitable retort to the unerring truth of his last statement. She gathered her courage again—at least enough to brave the thunderbolts of the man's eyes—when, amazing her, Toby straightened his shoulders and looked directly into Cody's face. He sniffed loudly and wiped his coat sleeve across his nose.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I'm sorry, sir,\" Toby said in a cracked voice. \"I thought it would be like the pictures in those penny books my friend Eddie has. It's not. It's awful.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Cody sighed and stood up. \"Real life's very seldom like it's painted in some trashy book, son. Remember that, will you?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Yes, sir,\" Toby replied. \"I will. And... and thank you for protecting my sister and me. It... it could have been one of us who got killed.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Cody reached down and gave Toby's shoulder a comforting pat before he pushed him toward Shanna. \"Go on over to your sister now. We've got some robbers to catch.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I hope you get 'em.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Me, too.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Cody, I've got your horse here,\" the sheriff said from behind him. \"We've got to ride. That snowstorm's gonna cover their tracks pretty quick.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Cody turned and took the reins Dan held out to him. Disregarding the stirrups, he mounted the dun stallion from the walkway. He checked the stallion's movement for a moment and glanced over at the blond woman. An icy blue gaze met his and he pulled his Stetson down another inch over his eyes before he reined his horse around to follow Dan.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The first pellets of hard snow hit his face beneath the shelter of his hat brim, driven by the rising wind. He glanced overhead at the thick black clouds and knew without a doubt the robbers had planned their getaway well. There wasn't a chance in hell they could catch them before the snow obliterated their trail.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("But he'd much rather be out chasing the bandits in this frigid weather than quickfrozen beneath the arctic blue gaze of that little boy's sister.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Cody shivered from a feeling totally unlinked to the wintry weather. Undoubtedly his hunch about the woman would turn out wrong. The downtrodden, gossamer angel described to him would never have braved his male ire or let a profanity pass her lips. The dog-eared photo he had seen years ago had still been clear enough to show the wistful expression on the woman's face, completely opposite from the mystical daggers shooting at him from Shanna's eyes. At one point, he'd even had to consciously will himself not to throw up an arm to ward the daggers off. Besides, she was much too young—and the boy himself had told Cody she was his sister.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Damn, she was beautiful, though. He gripped his reins tighter in an effort to still the tingle in his fingertips at the remembered feel of her skin. Blue-eyed blonds had always been his weakness—her delft blue eyes and porcelain complexion had been what first attracted him to Nancy, his dead wife. That had to be what stirred him about Toby's sister—the promise of fragile femininity her coloring implied.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Shanna's outwardly delicate demeanor covered fire and grit, however, and he'd never cared for independent, outspoken women. Women should be sheltered, cared for, pampered. In return, they made a man feel taller than a mountain and able to easily accomplish the most difficult tasks. Women had no business traipsing around the country alone, without a man to keep them safe from danger.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He'd felt that masculine competence for only a few moments around Shanna, protecting her and the little boy called Toby from harm, even at the expense of losing the money he had deposited in the bank. She damned sure didn't appreciate it. Hell, he couldn't have done anything different—wouldn't have left her in danger even if he'd known in advance how she would turn from a soft, appreciative lady into a barely held in check spitfire.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i', [_vm._v("Women,")]), _vm._v(" Cody mused to himself, urging his stallion into a canter when he realized he was falling behind the posse. He better keep his thoughts centered on his lost money, instead of recalling how Shanna's quick personality change had brought to mind a feisty palomino mare determined to elude capture one spring. That mare had never become a satisfactory saddle mount, only settling down when allowed to run free in the pasture next to his father's chestnut stud, Copper.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("But the pair of them produced offspring unequalled in the state—at least after the colts were caught and trained. That usually happened only after the mare came into heat again and dropped her overprotective vigilance of her current colt.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Someone else would have to stand stud to that palomino mare back in town. Cody leaned down into the shelter of his dun's neck as the frigid wind whipped by him. He'd done all that could be expected of him. Besides, ice and fire both in a woman were contradictions he didn't care for. Intriguing, definitely—but only in passing.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("* * *")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Shanna waited until the last rider from the posse rode out of sight before she relaxed her angry stance and looked down at Toby. When he quickly ducked his head to hide his tremulous gaze, Shanna's heart melted and she reached out a hand to brush at one dirty cheek. She couldn't bring herself to scold him again. That man had done a good enough job of that—too blasted good.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Toby,\" she said quietly in an effort to calm the indignation still seething in her mind, \"let's get in out of this weather and find a better bandage for your hand.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Toby raised his head hopefully. \"You... you're not mad at me, are you, Shanna?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Shanna hesitated, then decided to be honest with him. \"Yes. Yes, I am, Toby. But I don't think there's anything I could say to you that would be more effective than what you've just seen.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Shanna knelt and pulled him close. \"Toby. Oh, Toby, you're going to have to learn to listen to me out here. It's not like back in New York. Remember, we talked about this time after time before we left.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I remember,\" Toby said solemnly. \"And I'm really trying to be good. Honest I am.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Shanna nodded and hugged him before rising to her feet. \"I know you are, Toby.\" She stared up the deserted street again, giving herself a little shake when she found her eyes watering with strain as she stared at the trees where the posse had disappeared. She had to get Toby in out of the cold. But her eyes fell on the dark spot where the young man had lain, now quickly being covered with blowing snow.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Oh God,\" she said around a shudder. \"Maybe we should go back. Maybe this was the wrong thing to do.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"No!\" Toby grabbed her hand frantically, tugging on it, forcing her attention back to him. \"No, Shanna! We can't go back. He'll send me away and I couldn't stand it. You promised you wouldn't let him do that. Please, Shanna. Don't make me go back there!\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Toby, calm down. I didn't mean it. I was... I was just thinking out loud. We'll stay together, Toby, no matter what it takes.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Cross your heart?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Shanna resolutely fixed a sincere gaze on her face and drew an \"X\" across her chest. \"I promise, Toby. Cross my heart and hope to die.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Sh... Shanna,\" Toby asked in a quavering voice. \"Do you think our promises to each other would be just as good if we left off that last part?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"About hoping to die?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Y... yeah.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Shanna squeezed his small hand reassuringly. \"I'm sure they would be. Now, do you think we can find our bags? I hope they haven't gotten damaged.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"There they are.\" Toby pulled his hand free and pointed at the land office wall.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Before Shanna could move, the grizzled little man from the land office stepped out the door. \"Here, I'll help you, Miss. Well, my, my. What have we here?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Shanna blushed violently when Tom bent down and picked up a sheer object from the walkway. The lacy chemise dangled from his gnarled finger, the fine quality of the silk garment showing through despite the mud spattering it. Shanna saw several other of her more intimate garments spilling out of the carpetbag, which had popped the clasp when she dropped it.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Ain't this purty,\" Tom said with a soft chuckle. \"Why, I bet ain't a woman in town's got anything this nice.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Shanna jumped forward and swiped the chemise from his hand. Ducking her blood-red face, she bent down and stuffed the chemise and other lingerie back into the bag.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"That wasn't very nice of you, Mister,\" Toby said. \"Men ain't supposed to make fun of all them gee gaws women wear.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Aren't,\" Shanna corrected as she snapped her bag shut.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Yeah, men aren't supposed to do that,\" Toby said. \"Don't you know that, Mister?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Tom chuckled loudly and patted Toby on the shoulder. \"You're right, son. Men ain't... aren't supposed to make fun of such as that. I apologize, Miss. Guess this young whippersnapper's got better manners than me.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I ought to have good manners.\" Toby gave a long-suffering sigh. \"Every time I turn around, Shanna's telling me don't do this or do do that.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Tom threw his head back, a loud guffaw erupting from his wattled throat. \"Well, son,\" he said when he could control his laughter. \"Like you heard a minute ago, things are different out here. Best you keep that in mind. And I sure hate to have to be the one to tell you this, but you might need to learn a whole different set of manners out here than what you're used to.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Oh, no,\" Toby said around a groan. \"Is that true, Shanna?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Good manners are the same anywhere, Toby,\" Shanna replied in a stiff voice, picking up her bag. \"And I don't need "), _c('i', [_vm._v("anyone")]), _vm._v(" butting his nose into how I'm raising you,\" she continued with a cutting glance at Tom. \"Get your bag and let's go on to the hotel. It's freezing out here.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"'Pologize again, Miss,\" Tom said with a shrug. \"Just tryin' to be friendly. Want some help with those bags?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"We can manage, but thank you—for the offer of help with the bags.\" Shanna started off down the walkway, with Toby following a step behind her.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"We got a good laundry in town that can clean your stuff, Miss,\" Tom called after her. \"But I'd make sure they use something besides that lye soap they usually wash things in, if they do your things.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Shanna straightened her shoulders and ignored him this time, her heel taps ringing loudly on the walkway as she marched away. She glanced quickly through the shattered windows of the bank as she passed, catching a glimpse of a white-haired man sitting slumped on a chair inside, his head cradled in his hands. Toby slowed his steps beside her and craned his neck to see through the broken windows, and she firmly placed her free hand against his back to urge him onward.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("At the hotel door, Shanna hesitated. \"We'll have to sign a register in here, Toby. Do you remember the name we're going to use?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Uh huh,\" Toby confirmed. \"It's Allen. You said it sounded enough like Alstyne that we wouldn't forget it, but we should drop the Van part of our name so P... Pop couldn't find us.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Toby sniffed back a short sob and tugged on Shanna's hand when she started through the door. \"Shanna. Shanna, can I...?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Shanna stopped and knelt again when she saw the tears threatening in Toby's blue eyes, cupping his small shoulders in her hands. \"What is it, Toby? Does your hand hurt? I can carry both bags.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"No. I can carry mine. I just... Shanna, can I still call him Pop? You said....\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Oh, Toby.\" Shanna wrapped her arms around him and pulled his head into her breasts. \"I don't know. It's... it's something we'll have to talk about later.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Toby buried his face for an instant, then stepped out of her arms and gave a manful sniff to control his misery. \"I'm all right now, Shanna,\" he managed to say. \"It's just so much has happened since Mama d... died.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I know, darling,\" Shanna said as she stood. \"And you're being awfully brave about all this. I promise, we'll get things worked out.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Just so "), _c('i', [_vm._v("you")]), _vm._v(" don't leave me, Shanna. Just so you promise "), _c('i', [_vm._v("you'll")]), _vm._v(" always be with me.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I promise, Toby. Cross my heart and... cross my heart.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Shanna pushed open the hotel door and they stepped into the welcome warmth inside the lobby. Looking toward the desk on the far side of the room, she found it empty, but a small bell sat on the edge of the desk to call the clerk to the front. Shifting her carpetbag to the other hand to relieve the strain on her arm, she walked across the lobby.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Liberty,\" she heard Toby say beside her.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"What, Toby?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Liberty. That's the name on the front of the hotel. I saw it when the stagecoach passed by. Is this town called Liberty, Shanna?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Yes, Toby. We're in Liberty, Missouri.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"You never told me where we were going.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"No, I guess I didn't,\" Shanna murmured distractedly as she tried to decide whether to use the bell or wait for the clerk to appear. She hated to shatter the silence of the quiet lobby with a loud, ringing bell, but neither was she prepared to wait much longer for that bath. And she ached for some privacy to sort out the confusion of the past few minutes, not the least of which was why she reacted so violently to that man's change in attitude toward her.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("At first, she had felt drawn to him, almost sensing a haven in his strong arms, where she could pour out the nightmarish anguish and frustration of the last few weeks. Then he had turned on her, demanding her identity and muddling her thoughts as the fear that he knew who she really was raced through her mind.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Her initial yearning was only the result of her exhaustion and gratitude, she told herself. She would have felt grateful to a man with a potbelly and bad breath for rescuing her and Toby. That the man had a trim waist she had to rigidly keep from flinging her arms around and a muscular chest she could have buried her face on very willingly....")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Is that something else we'll talk about later, Shanna?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Hum, Toby?\" And his breath had definitely not been sour—more like a hint of a spring breeze on her cheeks when she turned around to get her first decent look at him.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Where we're going. Will we talk about that soon?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Yes, Toby.\" Shanna tilted her chin decisively and reached out to tap the bell. Darn it, the man had shown his true character when he tried to discipline Toby, no matter how blatantly masculine he was.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("While she waited for the clerk to answer the ringing summons, Toby's words slowly sank into Shanna's preoccupied thoughts and she determinedly pondered them in an attempt to keep the other unwelcome reflections at bay.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("What the heck "), _c('i', [_vm._v("were")]), _vm._v(" they doing in Liberty, Missouri? Despite the hundreds of miles they had already traveled, this might be just the start of another long, dangerous quest, and what would she do if she placed Toby in danger again?")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("They could so easily have been shot. And almost worse than that—if anything could be deemed worse than a sure, quick death like that suffered by the young man in the street—was the fact of their rescue by that stranger with the quicksilver personality. Admittedly, he had risked his life to shove them inside the land office. If he hadn't, there might only be fading blood spots on the wooden walkway to mark her and Toby passing through Liberty, Missouri.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("But she wasn't going to think about the stranger....")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Shanna shivered as she also tried to push the vision of twin blood spots away, and her toe tapped impatiently while she waited for the desk clerk to respond. She owed that man more than she could ever repay, she acknowledged to herself. Why had he done such an about face when she attempted to express her gratefulness, and possibly even traumatized Toby with his ill-conceived attempt at punishment? What unmitigated gall he had—forcing Toby to look at that dead body. Who did he think he was, acting as though saving their lives gave him the right to offer unasked-for discipline to a child not his own?")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She couldn't even recall his name, she realized, not too unhappy with that fact and still trying to ignore the nagging persistence of him in her mind. Probably she would never see him again, since she didn't plan on staying in Liberty very long.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("And what the heck "), _c('i', [_vm._v("were")]), _vm._v(" they doing in Liberty, Missouri, her mind repeated. Shanna slipped her hand into her cloak pocket, caressing the letters left by her dead mother, and the feel of them effectively brought her critical predicament to the forefront. As before, the remembered words in the letter addressed to her didn't bring much comfort, and she almost wished she hadn't probed into her mother's things after her death.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("But what else could she have done? Even Shanna's father didn't know about the secret drawer in Diedre Van Alstyne's writing desk—the drawer where her mother allowed Shanna to hide childhood treasures. It was a place only she and Shanna should know about, Diedre had insisted.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("How close she had always thought she and her mother to be. How could her mother have withheld such a terrible secret from her? Recalling the final, bitter face-off with her father, Shanna confronted the fact that he had known all along. So many things had become clear after she read the revelations in the one letter, even the probable reason her father always treated Toby, who was his son and heir, as though he were an unwelcome presence in his life, no matter how hard Toby strived to win Christian Van Alstyne's love.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i', [_vm._v("Shanna, darling. Please don't hate me.")])])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Shanna fingered the open letter in her pocket, running her finger along the jagged edge. She knew its contents by heart—the first few words burned into her mind. At this point she didn't know if she hated her mother or not, but she couldn't let her confusion overshadow her love for her small brother. She shied away from the distinction her mind tried to form and reached out to give the bell another firm tap, hoping the noise her action prompted would put an end to the racing thoughts in her mind.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i', [_vm._v("Shanna, darling. Please don't hate me.")]), _vm._v(" The words from her mind chased the echoes of the bell around the lobby.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23c79263","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section6.vue
// module id = 75
// module chunks = 0